import script from "./ImageSlideshow.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSlideshow.vue?vue&type=script&setup=true&lang=js"

import "./ImageSlideshow.vue?vue&type=style&index=0&id=204e7887&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204e7887"]])

export default __exports__